import { doc, getDoc, collection, query, where, getDocs, getFirestore } from 'firebase/firestore';
import firebaseApp from '../../firebase/credenciales';

const db = getFirestore(firebaseApp);
const DEFAULT_PDT_PLAME_CODES = {
  rem: {
    remuneracion_basica: '0121',
    remuneracion_permanente: '0122',
    horas_extras_25: '0105',
    horas_extras_35: '0106',
    horas_extras_100: '0107',
    remuneracion_vacacional: '0118',
    asignacion_familiar: '0201',
    bonificaciones_regulares: '0306',
    subsidio_incapacidad: '0915',
    devolucion_renta_5ta: '0928',
    adelanto: '0701',
    cuota_sindical: '0702',
    otros_descuentos: '0706',
    spp_comision: '0601',
    conafovicer: '0602',
    prima_seguro_afp: '0606',
    spp_aporte_obligatorio: '0608',
    spp_aporte_voluntario: '0609',
    otros_aportes_trabajador: '0611',
    renta_5ta: '0605',
    spp_aporte_voluntario_empleador: '0801',
    vida_ley: '0803',
    otras_aportaciones_empleador: '0809',
    essalud_empleador: '0804',
    sis_empleador: '0811',
    otros_conceptos: '0917',
  },
};
const DEFAULT_SOURCE_PATH_BY_KEY = {
  remuneracion_basica: 'computed.remuneracion_basica',
  remuneracion_permanente: 'sueldo_permanente',
  horas_extras_25: 'ingresos.horas_extras_25',
  horas_extras_35: 'ingresos.horas_extras_35',
  horas_extras_100: 'ingresos.horas_extras_100',
  remuneracion_vacacional: 'computed.remuneracion_vacacional',
  asignacion_familiar: 'asignacion_familiar',
  bonificaciones_regulares: 'ingresos.bonificacion_regular',
  subsidio_incapacidad: 'computed.subsidio_incapacidad',
  devolucion_renta_5ta: 'devolucion_renta_5ta',
  adelanto: 'descuentos.adelantos',
  cuota_sindical: 'descuentos.cuota_sindical',
  otros_descuentos: 'descuentos.otros_descuentos',
  spp_comision: 'descuentos.sistema_pension.comision',
  conafovicer: 'descuentos.conafovicer',
  prima_seguro_afp: 'descuentos.sistema_pension.seguro',
  spp_aporte_obligatorio: 'descuentos.sistema_pension.fondo',
  spp_aporte_voluntario: 'descuentos.sistema_pension.voluntario',
  otros_aportes_trabajador: 'descuentos.otros_aportes_trabajador',
  renta_5ta: 'descuentos.renta_5ta',
  spp_aporte_voluntario_empleador: 'aportaciones.voluntario_empleador',
  vida_ley: 'aportaciones.vida_ley',
  otras_aportaciones_empleador: 'aportaciones.sctr',
  essalud_empleador: 'aportaciones.essalud',
  sis_empleador: 'aportaciones.sis',
};
const DEFAULT_REM_CATALOG = [
  { key: 'horas_extras_25', source_path: DEFAULT_SOURCE_PATH_BY_KEY.horas_extras_25, required: true },
  { key: 'horas_extras_35', source_path: DEFAULT_SOURCE_PATH_BY_KEY.horas_extras_35, required: true },
  { key: 'horas_extras_100', source_path: DEFAULT_SOURCE_PATH_BY_KEY.horas_extras_100, required: true },
  { key: 'remuneracion_vacacional', source_path: DEFAULT_SOURCE_PATH_BY_KEY.remuneracion_vacacional, required: true },
  { key: 'remuneracion_basica', source_path: DEFAULT_SOURCE_PATH_BY_KEY.remuneracion_basica, required: true },
  { key: 'remuneracion_permanente', source_path: DEFAULT_SOURCE_PATH_BY_KEY.remuneracion_permanente, required: true },
  { key: 'asignacion_familiar', source_path: DEFAULT_SOURCE_PATH_BY_KEY.asignacion_familiar, required: true },
  { key: 'bonificaciones_regulares', source_path: DEFAULT_SOURCE_PATH_BY_KEY.bonificaciones_regulares, required: true },
  { key: 'subsidio_incapacidad', source_path: DEFAULT_SOURCE_PATH_BY_KEY.subsidio_incapacidad, required: true },
  { key: 'devolucion_renta_5ta', source_path: DEFAULT_SOURCE_PATH_BY_KEY.devolucion_renta_5ta, required: true },
  { key: 'adelanto', source_path: DEFAULT_SOURCE_PATH_BY_KEY.adelanto, required: true },
  { key: 'cuota_sindical', source_path: DEFAULT_SOURCE_PATH_BY_KEY.cuota_sindical, required: true },
  { key: 'otros_descuentos', source_path: DEFAULT_SOURCE_PATH_BY_KEY.otros_descuentos, required: true },
  { key: 'spp_comision', source_path: DEFAULT_SOURCE_PATH_BY_KEY.spp_comision, required: true },
  { key: 'conafovicer', source_path: DEFAULT_SOURCE_PATH_BY_KEY.conafovicer, required: true },
  { key: 'prima_seguro_afp', source_path: DEFAULT_SOURCE_PATH_BY_KEY.prima_seguro_afp, required: true },
  { key: 'spp_aporte_obligatorio', source_path: DEFAULT_SOURCE_PATH_BY_KEY.spp_aporte_obligatorio, required: true },
  { key: 'spp_aporte_voluntario', source_path: DEFAULT_SOURCE_PATH_BY_KEY.spp_aporte_voluntario, required: true },
  { key: 'otros_aportes_trabajador', source_path: DEFAULT_SOURCE_PATH_BY_KEY.otros_aportes_trabajador, required: true },
  { key: 'renta_5ta', source_path: DEFAULT_SOURCE_PATH_BY_KEY.renta_5ta, required: true },
  { key: 'spp_aporte_voluntario_empleador', source_path: DEFAULT_SOURCE_PATH_BY_KEY.spp_aporte_voluntario_empleador, required: true },
  { key: 'vida_ley', source_path: DEFAULT_SOURCE_PATH_BY_KEY.vida_ley, required: true },
  { key: 'otras_aportaciones_empleador', source_path: DEFAULT_SOURCE_PATH_BY_KEY.otras_aportaciones_empleador, required: true },
  { key: 'essalud_empleador', source_path: DEFAULT_SOURCE_PATH_BY_KEY.essalud_empleador, required: false },
  { key: 'sis_empleador', source_path: DEFAULT_SOURCE_PATH_BY_KEY.sis_empleador, required: true },
];
const COMPANY_PDT_PLAME_OVERRIDES = {
  "20609212102": {
    rem: {
      horas_extras_25: "0105",
      horas_extras_35: "0106",
      horas_extras_100: "0107",
      remuneracion_vacacional: "0118",
      remuneracion_basica: "0121",
      remuneracion_permanente: "0122",
      asignacion_familiar: "0201",
      bonificaciones_regulares: "0306",
      devolucion_renta_5ta: "0928",
      adelanto: "0701",
      cuota_sindical: "0702",
      otros_descuentos: "0706",
      spp_comision: "0601",
      conafovicer: "0602",
      renta_5ta: "0605",
      prima_seguro_afp: "0606",
      spp_aporte_obligatorio: "0608",
      spp_aporte_voluntario: "0609",
      otros_aportes_trabajador: "0611",
      spp_aporte_voluntario_empleador: "0801",
      vida_ley: "0803",
      otras_aportaciones_empleador: "0809",
      sis_empleador: "0811",
    },
  },
};

/**
 * Genera los archivos PLAME (.rem y .jor) según especificaciones de SUNAT
 * @param {string} planillaId - ID de la planilla a exportar
 */
export const generarArchivosPLAME = async (planillaId) => {
  try {
    // 1. Obtener datos de la planilla
    const planillaRef = doc(db, "pl_planillas", planillaId);
    const planillaDoc = await getDoc(planillaRef);
    if (!planillaDoc.exists()) throw new Error("Planilla no encontrada");
    const planilla = planillaDoc.data();
    
    // 1.1 Obtener configuración de la empresa para detectar SIS
    const configRef = doc(db, "pl_configuracion", planilla.ruc_empresa);
    const configDoc = await getDoc(configRef);
    if (configDoc.exists()) {
      planilla.config = configDoc.data();
    }
    
    // 1.2 Obtener códigos PDT PLAME por empresa (personalizables)
    const pdtConfig = await obtenerConfiguracionPdtPlame(planilla.ruc_empresa);
    planilla.pdt_plame = pdtConfig;

    // 2. Obtener detalles de la planilla
    const detalleQuery = query(
      collection(db, "pl_planilla_detalle"),
      where("planilla_id", "==", planillaId)
    );
    const detalleSnapshot = await getDocs(detalleQuery);
    const detallesRaw = [];
    detalleSnapshot.forEach(doc => detallesRaw.push(doc.data()));

    // 2.1 Enriquecer con datos del maestro de empleados (para obtener CUSPP)
    const detalles = await Promise.all(detallesRaw.map(async (d) => {
      let enriquecido = { ...d };
      if (d.empleado_id) {
        const empRef = doc(db, "pl_empleados", d.empleado_id);
        const empDoc = await getDoc(empRef);
        if (empDoc.exists()) {
          const empData = empDoc.data();
          enriquecido = { ...d, cuspp: empData.cuspp || d.cuspp };
        }
        
        // Obtener historial médico para determinar el tope de 20 días
        const anio = planilla.periodo.split('-')[0];
        const historialMedico = await obtenerHistorialMedicoAnual(planilla.ruc_empresa, d.empleado_id, anio, planilla.periodo);
        enriquecido.dias_medicos_previos = historialMedico;
      }
      return enriquecido;
    }));

    // 3. Formatear periodo para nombre de archivo (YYYYMM)
    const periodoFormateado = planilla.periodo.replace('-', '');

    // 4. Generar nombres de archivos según formato PLAME (0601YYYYMMRUC.ext)
    const baseNombre = `0601${periodoFormateado}${planilla.ruc_empresa}`;

    // 5. Generar contenido de los archivos
    const remArchivo = generarREM(detalles, planilla, pdtConfig);
    const jorArchivo = generarJOR(detalles);
    // 6. Descargar archivos con delay para asegurar descarga múltiple
    descargarArchivo(`${baseNombre}.rem`, remArchivo);
    await timer(500);
    descargarArchivo(`${baseNombre}.jor`, jorArchivo);

    return {
      success: true,
      message: "Archivos .rem y .jor generados exitosamente"
    };
  } catch (error) {
    console.error("Error al generar archivos PLAME:", error);
    throw error;
  }
};

/**
 * Genera el archivo .rem (Remuneraciones) - Una fila por cada concepto/trabajador
 */
const generarREM = (detalles, planilla, pdtConfig = DEFAULT_PDT_PLAME_CODES) => {
  const lineas = [];

  detalles.forEach(d => {
    const tipoDoc = getTipoDocCode(d.tipo_documento || 'DNI');
    const numDoc = d.empleado_id || '00000000';

    // Análisis de Subsidios (Regla de los 20 días)
    const diasMedicosMes = Number(d.dias_descanso_medico || 0);
    const diasPrevios = Number(d.dias_medicos_previos || 0);
    const rmBasica = Number(d.sueldo_base || 0);
    const valorDia = rmBasica / 30;

    let monto0121 = rmBasica;
    let monto0915 = 0;

    if (diasMedicosMes > 0) {
      const diasRestantesTope = Math.max(0, 20 - diasPrevios);
      const diasEnTope = Math.min(diasMedicosMes, diasRestantesTope);
      const diasExceso = Math.max(0, diasMedicosMes - diasEnTope);

      if (diasExceso > 0) {
        monto0915 = Number((diasExceso * valorDia).toFixed(2));
        monto0121 = Number((rmBasica - monto0915).toFixed(2));
      }
    }

    const baseContext = { monto0121, monto0915 };
    const catalogoRem = buildRemCatalogItems(pdtConfig);
    const conceptos = catalogoRem.map((item) => ({
      cod: getPdtCode(pdtConfig, `rem.${item.key}`, item.fallback || ''),
      monto: resolveMontoBySourcePath(d, item.source_path, item.key, baseContext),
      required: item.required !== false,
    }));

    // Otros bonos que no son conceptos fijos
    if (d.bonos && typeof d.bonos === 'object') {
      Object.values(d.bonos).forEach(monto => {
        if (monto > 0) conceptos.push({ cod: getPdtCode(pdtConfig, 'rem.otros_conceptos', '0917'), monto }); // Otros conceptos
      });
    }

    // Agregar líneas para conceptos
    conceptos.forEach(c => {
      const monto = Number(c.monto || 0);
      
      // Regla estricta: incluir si monto > 0 O si el concepto es requerido (aunque sea 0.00)
      if (monto > 0 || c.required) {
        lineas.push([
          tipoDoc,
          numDoc,
          c.cod,
          formatoMontoPLAME(monto), // Devengado
          formatoMontoPLAME(monto), // Pagado
          ''
        ].join('|'));
      }
    });

    // Descuentos (si aplica, opcional para ciertos archivos .rem)
    // El PLAME generalmente pide ingresos en .rem. Descuentos de ley van en otros archivos o con otros códigos.
  });

  return lineas.join('\r\n') + '\r\n';
};

/**
 * Genera el archivo .jor (Jornada Laboral)
 */
const generarJOR = (detalles) => {
  return detalles.map(d => {
    const tipoDoc = getTipoDocCode(d.tipo_documento || 'DNI');
    const numDoc = d.empleado_id || '00000000';
    
    // Horas Ordinarias
    const horasOrd = Math.floor(d.horas_trabajadas || 240);
    const minsOrd = Math.round(((d.horas_trabajadas || 240) % 1) * 60);

    // Horas Sobretiempo (Total de HE 25% + 35% + 100%)
    const totalHE = (Number(d.he_25) || 0) + (Number(d.he_35) || 0) + (Number(d.he_100) || 0);
    const horasExt = Math.floor(totalHE);
    const minsExt = Math.round((totalHE % 1) * 60);

    return [
      tipoDoc,
      numDoc,
      horasOrd,
      minsOrd,
      horasExt,
      minsExt,
      ''
    ].join('|');
  }).join('\r\n') + '\r\n';
};

// --- Utilidades de Mapeo ---

const getTipoDocCode = (tipo) => {
  const map = {
    'DNI': '01',
    'CE': '04',
    'PASAPORTE': '07',
    'PTP': '04' // Simplificado
  };
  return map[tipo.toUpperCase()] || '01';
};

const formatoMontoPLAME = (monto) => {
  return Number(monto || 0).toFixed(2);
};

const getValueByPath = (obj, path) => {
  if (!obj || !path) return undefined;
  return String(path)
    .split('.')
    .reduce((acc, part) => (acc && Object.prototype.hasOwnProperty.call(acc, part) ? acc[part] : undefined), obj);
};

const resolveMontoBySourcePath = (detalle, sourcePath, key, context = {}) => {
  if (sourcePath === 'computed.remuneracion_basica') return context.monto0121;
  if (sourcePath === 'computed.subsidio_incapacidad') return context.monto0915;
  if (sourcePath === 'computed.remuneracion_vacacional') {
    return detalle.gratificacion_trunca || detalle.vacaciones_truncas || detalle.vacaciones || 0;
  }

  const path = sourcePath || DEFAULT_SOURCE_PATH_BY_KEY[key];
  if (!path) return 0;

  const value = getValueByPath(detalle, path);
  if (value !== undefined && value !== null) return value;

  if (path === 'ingresos.horas_extras_25') return detalle.he_25_monto || 0;
  if (path === 'ingresos.horas_extras_35') return detalle.he_35_monto || 0;
  if (path === 'ingresos.horas_extras_100') return detalle.he_100_monto || 0;
  if (key === 'otras_aportaciones_empleador') return detalle.aportaciones?.sctr || detalle.aportaciones?.otras || 0;

  return 0;
};

const getPdtCode = (config, path, fallback) => {
  const parts = String(path || "").split('.');
  let current = config || {};
  for (const part of parts) {
    if (current && Object.prototype.hasOwnProperty.call(current, part)) {
      current = current[part];
    } else {
      return fallback;
    }
  }
  const code = String(current || "").trim();
  return code || fallback;
};

const buildRemCatalogItems = (config) => {
  const catalogo = config?.catalogo;
  const seccionesRem = ['ingresos_rem', 'descuentos_rem', 'aportes_trabajador_rem', 'aportes_empleador_rem'];
  const fromCatalog = [];

  seccionesRem.forEach((sectionId) => {
    const items = catalogo?.[sectionId];
    if (!Array.isArray(items)) return;
    items.forEach((item) => {
      const key = String(item?.key || '').trim();
      if (!key) return;
      fromCatalog.push({
        key,
        source_path: String(item?.source_path || DEFAULT_SOURCE_PATH_BY_KEY[key] || '').trim(),
        required: item?.required !== false,
        fallback: DEFAULT_PDT_PLAME_CODES.rem[key] || '',
      });
    });
  });

  if (fromCatalog.length > 0) return fromCatalog;
  return DEFAULT_REM_CATALOG.map((item) => ({
    ...item,
    fallback: DEFAULT_PDT_PLAME_CODES.rem[item.key] || '',
  }));
};

const obtenerConfiguracionPdtPlame = async (rucEmpresa) => {
  const config = JSON.parse(JSON.stringify(DEFAULT_PDT_PLAME_CODES));
  config.catalogo = {};
  try {
    const localOverride = COMPANY_PDT_PLAME_OVERRIDES[String(rucEmpresa || "")];
    if (localOverride?.rem) config.rem = { ...config.rem, ...localOverride.rem };

    if (!rucEmpresa) return config;
    const refConfig = doc(db, "pl_pdt_plame", String(rucEmpresa));
    const snap = await getDoc(refConfig);
    if (!snap.exists()) return config;

    const data = snap.data() || {};
    const sourceCodes = data.codigos || data.codes || data;
    if (sourceCodes?.rem && typeof sourceCodes.rem === 'object') {
      config.rem = { ...config.rem, ...sourceCodes.rem };
    }
    if (data.catalogo && typeof data.catalogo === 'object') {
      config.catalogo = data.catalogo;
    }
    return config;
  } catch (error) {
    console.warn("⚠️ No se pudo cargar pl_pdt_plame, usando códigos por defecto:", error);
    return config;
  }
};

const descargarArchivo = (nombre, contenido) => {
  const blob = new Blob([contenido], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

const timer = (ms) => new Promise(res => setTimeout(res, ms));

/**
 * Obtiene el total de días de descanso médico acumulados en el año previo al periodo actual
 */
const obtenerHistorialMedicoAnual = async (ruc, empleadoId, anio, periodoActual) => {
  try {
    const q = query(
      collection(db, "pl_planilla_detalle"),
      where("ruc_empresa", "==", ruc),
      where("empleado_id", "==", empleadoId),
      where("periodo", ">=", `${anio}-01`),
      where("periodo", "<", periodoActual)
    );
    const snapshot = await getDocs(q);
    let totalDias = 0;
    snapshot.forEach(doc => {
      totalDias += Number(doc.data().dias_descanso_medico || 0);
    });
    return totalDias;
  } catch (error) {
    console.warn("⚠️ Error obteniendo historial médico:", error);
    return 0;
  }
};
